import { gql } from "@apollo/client";

export const CREATE_ORDERED_PART_MUTATION = gql`
  mutation CreateOrderedPart($orderedPart: CUDOrderedPartInput!) {
    createOrderedPart(orderedPart: $orderedPart) {
      _id
      name
      tickets {
        _id
        ticket
        ticket_id
        id
      }
      vendor_part_number
      received_date
      description
      vendor
      status
      ordered_date
      po_number
      quantity
      each_price
      shipping_price
      total_price
      payment_method
      tracking_number
      eta
      notes
      created_at
      updated_at
    }
  }
`;

export const UPDATE_ORDERED_PART_MUTATION = gql`
  mutation UpdateOrderedPart($_id: ID!, $orderedPart: CUDOrderedPartInput!) {
    updateOrderedPart(_id: $_id, orderedPart: $orderedPart) {
      _id
      name
      tickets {
        _id
        ticket
        id
        ticket_id
      }
      vendor_part_number
      received_date
      received
      description
      vendor
      status
      ordered_date
      po_number
      quantity
      each_price
      shipping_price
      total_price
      payment_method
      tracking_number
      eta
      notes
      created_at
      updated_at
    }
  }
`;

export const DELETE_MANY_ORDERED_PARTS_MUTATION = gql`
  mutation DeleteManyOrderedParts($orderedParts: [CUDOrderedPartInput]!) {
    deleteManyOrderedParts(orderedParts: $orderedParts) {
      _id
    }
  }
`;
